import {
  ChangeDetectionStrategy,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  InjectionToken,
  Input,
  Output,
} from '@angular/core';

export const DIALOG_TOKEN = new InjectionToken<DialogComponent>('DIALOG_TOKEN');

export interface DialogConfig {
  hideBackdrop?: boolean;
  disableBackdropDismiss?: boolean;

  contentContainerClass?: string;
  dialogContainerClass?: string;

  startOpen?: boolean;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-dialog',
  templateUrl: './dialog.component.html',
  standalone: false,
  providers: [{ provide: DIALOG_TOKEN, useExisting: DialogComponent }],
})
export class DialogComponent implements AfterViewInit {
  private readonly cdr = inject(ChangeDetectorRef);

  @Output() opened = new EventEmitter();
  @Output() closed = new EventEmitter<unknown>();

  @Input() config?: DialogConfig;

  /** Stable origin so CDK doesn't see a new object every change-detection cycle. */
  readonly overlayOrigin = { x: 0, y: 0 };

  _open = false;

  onOverlayKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      if (this.config?.disableBackdropDismiss) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      this.close();
    }
  }

  onBackdropClick() {
    if (!this.config?.disableBackdropDismiss) this.close();
  }

  open() {
    this._open = true;
    this.opened.emit();
    // CDK ConnectedOverlay attaches in ngOnChanges; flush so open binds immediately.
    this.cdr.detectChanges();
  }

  close(data?: unknown) {
    if (!this._open) return;
    this._open = false;
    this.closed.emit(data);
    this.cdr.detectChanges();
  }

  ngAfterViewInit(): void {
    if (this.config?.startOpen) this.open();
  }
}
